import { Link, useNavigate } from "react-router-dom";
import "./address-list.css";
import HeaderOther from "../ui/header-other";
import { useContext, useEffect, useState } from "react";
import { cartContext } from "../../App";

export default function AddressList() {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const { setToSelectedAddress, addressList, userId, setToAddressList } = useContext(cartContext);
    const [addressData, setAddressData] = useState(addressList || []);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    // Fetch user address on component mount
    useEffect(() => {
        const fetchAddressData = async () => {
            try {
                setLoading(true);
                // Fetch userID from localStorage
                if (userId) {
                    fetch(`${BACKEND_URL}/get-user-address`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({ userId: userId }),
                    }).then(response => {
                    return response.json();
                    })
                    .then(data => {
                        console.log('Address data from server:', data);
                        if (data.success && data.address) {
                            setToAddressList(data.address);
                            setAddressData(data.address);
                        }
                    }).catch(error => {
                        console.error('Error fetching address data:', error);
                    }).finally(() => {
                        setLoading(false);
                    })
                } else {
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching address data: ', error);
            }
        }
        fetchAddressData();
    }, [BACKEND_URL]);

    const handleSelectAddress = (addr) => {
        setToSelectedAddress(addr);
        navigate(-1);
    };

    const handleDeleteAddress = async (addr) => {
        try {
            if (userId) {
                await fetch(`${BACKEND_URL}/delete-user-address`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${AUTH_TOKEN}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        userId: userId,
                        type: addr.type,
                    }),
                });
            }

            const updatedAddresses = addressData.filter(
                (item) => item.type !== addr.type,
            );

            setAddressData(updatedAddresses);
        } catch (error) {
            console.error("Delete error:", error);
            alert("Unable to delete address");
        }
    };

    if (loading) {
        return (
            <>
                <HeaderOther />
                <div className="loading-container">
                    <div className="spinner"></div>
                    <p>Fetching Address</p>
                </div>
            </>
        );
    }

    return (
        <>
            <HeaderOther title="My Addresses" description="Saved locations"/>

            <div className="saved-address-container">
                <Link to="/location-picker" className="add-address-btn">
                    + Add Address
                </Link>

                {addressData.length === 0 ? (
                    <div className="no-address">
                        <img
                            src="/icons/map.png"
                            alt="No address"
                            style={{
                                width: "180px",
                                height: "180px",
                            }}
                        />
                        <p>No Address Found</p>
                    </div>
                ) : (
                    addressData.map((addr, index) => (
                        <div key={index} className="address-card">
                            <div className="card-header">
                                <div className="badge">
                                    {String(addr.type).toUpperCase()}
                                </div>

                                <div className="icon-row">
                                    <Link
                                        to="/location-picker"
                                        state={{
                                            addressData: addr,
                                        }}
                                    >
                                        <img
                                            src="/icons/pencil.png"
                                            alt="edit"
                                            className="icon"
                                        />
                                    </Link>

                                    <img
                                        src="/delete.png"
                                        alt="delete"
                                        className="icon"
                                        onClick={() =>
                                            handleDeleteAddress(addr)
                                        }
                                    />
                                </div>
                            </div>

                            <div className="card-body">
                                <p className="name">{addr.address?.name}</p>

                                <p className="address">
                                    {addr.address?.addressLine1}{" "}
                                    {addr.address?.addressLine2}{" "}
                                    {addr.address?.area}
                                </p>

                                <p className="phone">
                                    📞 {addr.address?.phone}
                                </p>
                            </div>

                            <button
                                className="use-address-btn"
                                onClick={() => handleSelectAddress(addr)}
                            >
                                Use this address
                            </button>
                        </div>
                    ))
                )}
            </div>
        </>
    );
}
